import { VanillaNhostClient as k, NHOST_REFRESH_TOKEN_KEY as f, NhostProvider as N, NhostClient as d } from "@nhost/react";
export * from "@nhost/react";
import "isomorphic-unfetch";
import i from "js-cookie";
import { waitFor as m } from "xstate/lib/waitFor";
const u = "nhostSession", T = (s) => {
  const e = s && "auth" in s ? s.auth.getSession() : s;
  if (!e) {
    i.remove(u);
    return;
  }
  const { refreshToken: n, ...r } = e, o = /* @__PURE__ */ new Date();
  o.setSeconds(o.getSeconds() + e.accessTokenExpiresIn - 60), i.set(u, JSON.stringify(r), {
    sameSite: "strict",
    expires: o
  });
}, C = async (s, e) => {
  const n = new k({
    ...s,
    clientStorageType: "custom",
    clientStorage: {
      getItem: (t) => {
        var S;
        const a = t === f ? "refreshToken" : t, l = e.query[a], h = (S = i.get(t)) != null ? S : null, p = e.req.cookies[t];
        return typeof l == "string" ? l : h != null ? h : p;
      },
      setItem: (t, a) => {
        i.set(t, a, { httpOnly: !1, sameSite: "strict", expires: 30 });
      },
      removeItem: (t) => {
        i.remove(t);
      }
    },
    start: !1,
    autoRefreshToken: !1,
    autoSignIn: !0
  }), r = e.req.cookies[u], o = e.req.cookies[f], c = r && o && { ...JSON.parse(r), refreshToken: o };
  return n.auth.client.start({ initialSession: c }), await m(
    n.auth.client.interpreter,
    (t) => !t.hasTag("loading")
  ), n;
}, E = async (s, e) => {
  const n = await C(s, e), { accessToken: r, refreshToken: o, user: c } = n.auth.client.interpreter.getSnapshot().context;
  return n.auth.isAuthenticated() ? {
    accessToken: r.value,
    accessTokenExpiresIn: (r.expiresAt.getTime() - Date.now()) / 1e3,
    refreshToken: o.value,
    user: c
  } : null;
}, y = N, g = typeof window != "undefined";
class O extends d {
  constructor(e) {
    super({
      ...e,
      autoSignIn: g && e.autoSignIn,
      autoRefreshToken: g && e.autoRefreshToken,
      clientStorageType: "cookie"
    }), this.auth.onAuthStateChanged(() => {
      T(this);
    }), this.auth.onTokenChanged(T);
  }
}
export {
  O as NhostClient,
  y as NhostNextProvider,
  C as createServerSideClient,
  E as getNhostSession
};
//# sourceMappingURL=index.esm.js.map
